<!--
 * @Descripttion:
 * @Author: zenghua.wang
 * @Date: 2021-07-01 14:52:38
 * @LastEditors: zenghua.wang
 * @LastEditTime: 2021-08-09 17:17:14
-->
<template>
  <div>
    <el-button
      icon="el-icon-plus"
      type="primary"
      size="small"
      style="margin-bottom: 10px"
      @click="addParam"
    >新增</el-button>
    <el-button
      v-if="type==='query'"
      type="success"
      size="small"
      style="margin-bottom: 10px"
      @click="addPage"
    >快速生成分页参数</el-button>
    <el-table
      :data="list"
      border
      size="small"
      style="width: 100%"
    >
      <el-table-column
        :label="title"
        align="center"
      >
        <template slot-scope="scope">
          <el-input
            clearable
            placeholder="请输入"
            size="small"
            v-model="scope.row.param"
            @change="onSubmit"
          />
        </template>
      </el-table-column>
      <el-table-column
        label="类型"
        align="center"
        v-if="type === 'query'"
      >
        <template slot-scope="scope">
          <el-select
            size="small"
            clearable
            placeholder="请选择"
            v-model="scope.row.filedType"
            @change="onSubmit"
            style="width: 100%"
          >
            <el-option
              v-for="(item, index) in options.params"
              :key="index"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column
        label="默认值"
        align="center"
      >
        <template slot-scope="scope">
          <el-input
            clearable
            placeholder="请输入"
            size="small"
            v-model="scope.row.defValue"
            @change="onSubmit"
          />
        </template>
      </el-table-column>
      <el-table-column
        label="备注"
        align="center"
      >
        <template slot-scope="scope">
          <el-input
            clearable
            placeholder="请输入"
            size="small"
            v-model="scope.row.remark"
            @change="onSubmit"
          />
        </template>
      </el-table-column>
      <el-table-column
        fixed="right"
        label="操作"
        width="140"
        align="center"
      >
        <template slot-scope="scope">
          <el-button
            type="text"
            size="small"
            icon="el-icon-delete"
            @click="deleteParam(scope.$index)"
          >删除</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
export default {
  name: 'ApisConfig',
  props: {
    id: {
      type: String,
      default: ''
    },
    tenantId: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: '名称'
    },
    type: {
      type: String,
      default: ''
    },
    column: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {
      list: this.column,
      options: {
        params: [
          {
            label: 'string',
            value: 'string'
          },
          {
            label: 'int',
            value: 'int'
          },
          {
            label: 'array',
            value: 'array'
          }
        ]
      }
    }
  },
  watch: {
    column(val) {
      this.list = val
    },
    list: {
      handler(val) {
        this.$emit('update:column', val)
      },
      deep: true
    }
  },
  methods: {
    addParam() {
      // body只能添加一条
      let len = this.list.length
      if (this.type === 'body' && len === 1) {
        return
      }
      this.valid()
      this.list.push({
        mainConfigId: this.id,
        attribute: this.type,
        tenantId: this.tenantId,
        param: null,
        filedType: 'string',
        defValue: null,
        remark: null
      })
    },
    // 一键生成
    addPage() {
      let isPageNum = this.list.some(item => {
        return item.param === 'pageNum'
      })
      let isPageSize = this.list.some(item => {
        return item.param === 'pageSize'
      })

      if (!isPageNum) {
        this.list.push({
          mainConfigId: null,
          attribute: 'query',
          tenantId: null,
          param: 'pageNum',
          filedType: 'int',
          defValue: 1,
          remark: null
        })
      }

      if (!isPageSize) {
        this.list.push({
          mainConfigId: null,
          attribute: 'query',
          tenantId: null,
          param: 'pageSize',
          filedType: 'int',
          defValue: 10,
          remark: null
        })
      }
    },
    deleteParam(index) {
      this.list.splice(index, 1)
      this.onSubmit()
    },
    valid() {
      this.list = this.list.filter(item => {
        return item.param
      })
    },
    onSubmit() {
      this.valid()
      this.$emit('change', this.type, this.list)
    }
  }
}
</script>
